import _ from 'lodash';
import {LocaleData} from 'contexts/LocaleContext';
import {loadPages, loadSettings} from '../../common/configs/load.server';

export function getLocaleData<T>(
    map: Record<LocaleData['code'], T>,
    localeCode: LocaleData['code'],
) {
    return _.get(map, [localeCode]);
}

export async function getPageConfig<T>(
    pageName: string,
    localeCode: LocaleData['code'],
): Promise<T> {
    return __IS_SERVER__
        ? await loadPages(pageName, localeCode)
        : (
              await import(
                  /* webpackChunkName: "pageConfigs/[request]" */
                  `pageConfigs/${pageName}/${localeCode}.json`
              )
          )?.default;
}

export async function getSettings<T>(name: string, localeCode: LocaleData['code']): Promise<T> {
    return __IS_SERVER__
        ? await loadSettings(name, localeCode)
        : (
              await import(
                  /* webpackChunkName: "settings/[request]" */
                  `settings/${name}/${localeCode}.json`
              )
          )?.default;
}
